import React, { useEffect, useState } from 'react';
import { formatTime } from './WorldClock';

// The visitor's own time, in the browser's time zone, ticking every second
function LocalClock({ military }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <span className="fm-local-clock" aria-hidden="true" title="your local time">
      {formatTime(now, undefined, military)}
    </span>
  );
}

export default LocalClock;
